import { P, Span } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNewUserState } from '../context/useNewUserContext';

export interface IProps {
  currentStep?: number;
}

export const NewUserSidebar: FC<IProps> = ({ currentStep }: IProps) => {
  const { t } = useTranslation();
  const { user } = useNewUserState();

  if (currentStep !== 2 && currentStep !== 3) {
    return null;
  }

  return (
    <>
      {currentStep >= 2 && user.name && (
        <P bold={true}>
          {t('newUser.sidebar.user')}: <Span>{user.name}</Span>
        </P>
      )}

      {currentStep >= 3 && user.selectedAccessLevel && (
        <P bold={true}>
          {t('newUser.sidebar.accessLevel')}: <Span>{user.selectedAccessLevel.label}</Span>
        </P>
      )}
    </>
  );
};

export default NewUserSidebar;
